"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const FiltroBox_vue_1 = __importDefault(require("./FiltroBox.vue"));
const vue_property_decorator_1 = require("vue-property-decorator");
let FiltroSuperficies = class FiltroSuperficies extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.valor = this.value;
    }
    onValorChanged() {
        if (this.valor !== this.value) {
            this.$emit("input", this.valor);
        }
    }
    onValueChanged() {
        if (this.valor !== this.value) {
            this.valor = this.value;
        }
    }
    get placeholderTotal() {
        let min = `${this.valor.total[0]}  m&sup2;`;
        let max = `${this.valor.total[1]}  m&sup2;`;
        return `${min} - ${max}`;
    }
    get placeholderCubierta() {
        let min = `${this.valor.cubierta[0]}  m&sup2;`;
        let max = `${this.valor.cubierta[1]}  m&sup2;`;
        return `${min} - ${max}`;
    }
};
__decorate([
    vue_property_decorator_1.Prop({ type: Number, required: true }),
    __metadata("design:type", Number)
], FiltroSuperficies.prototype, "minTotal", void 0);
__decorate([
    vue_property_decorator_1.Prop({ type: Number, required: true }),
    __metadata("design:type", Number)
], FiltroSuperficies.prototype, "maxTotal", void 0);
__decorate([
    vue_property_decorator_1.Prop({ type: Number, required: true }),
    __metadata("design:type", Number)
], FiltroSuperficies.prototype, "minCubierta", void 0);
__decorate([
    vue_property_decorator_1.Prop({ type: Number, required: true }),
    __metadata("design:type", Number)
], FiltroSuperficies.prototype, "maxCubierta", void 0);
__decorate([
    vue_property_decorator_1.Prop({ type: Object, required: true }),
    __metadata("design:type", Object)
], FiltroSuperficies.prototype, "value", void 0);
__decorate([
    vue_property_decorator_1.Watch("valor"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], FiltroSuperficies.prototype, "onValorChanged", null);
__decorate([
    vue_property_decorator_1.Watch("value", { immediate: true, deep: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], FiltroSuperficies.prototype, "onValueChanged", null);
FiltroSuperficies = __decorate([
    vue_property_decorator_1.Component({ components: { FiltroBox: FiltroBox_vue_1.default } })
], FiltroSuperficies);
exports.default = FiltroSuperficies;
